package com.iregained.site.components.sections.home.styles

import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.css.s

val AudienceSelectionStyle = CssStyle {
    base {
        Modifier.transition(
                Transition.of("transform", 0.3.s), Transition.of("box-shadow", 0.3.s)
            ).boxShadow(0.px, 4.px, 15.px, color = rgba(0, 0, 0, 0.05f))
    }
    hover {
        Modifier.translateY((-5).px) // Lifts the card up
            .boxShadow(0.px, 15.px, 30.px, color = rgba(0, 0, 0, 0.15f)) // Expands the shadow
    }
}